var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    fill: "#EAF3FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#4C95F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 12.5C24.4938 12.5 28.2322 15.7331 29.0159 20C28.2322 24.2668 24.4938 27.5 20.0004 27.5C15.5069 27.5 11.7686 24.2668 10.9849 20C11.7686 15.7331 15.5069 12.5 20.0004 12.5ZM20.0004 25.8333C23.5301 25.8333 26.5504 23.3767 27.3149 20C26.5504 16.6234 23.5301 14.1667 20.0004 14.1667C16.4707 14.1667 13.4503 16.6234 12.6858 20C13.4503 23.3767 16.4707 25.8333 20.0004 25.8333ZM20.0004 23.75C17.9293 23.75 16.2504 22.0711 16.2504 20C16.2504 17.9289 17.9293 16.25 20.0004 16.25C22.0714 16.25 23.7504 17.9289 23.7504 20C23.7504 22.0711 22.0714 23.75 20.0004 23.75ZM20.0004 22.0833C21.151 22.0833 22.0837 21.1506 22.0837 20C22.0837 18.8494 21.151 17.9167 20.0004 17.9167C18.8498 17.9167 17.917 18.8494 17.917 20C17.917 21.1506 18.8498 22.0833 20.0004 22.0833Z",
    fill: "#4C95F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.462a87a590a4e26e160a4dbfea856232.svg";
export { ForwardRef as ReactComponent };